import { render } from "./ItpatrutM.vue?vue&type=template&id=4489ccd0&scoped=true"
import script from "./ItpatrutM.vue?vue&type=script&lang=js"
export * from "./ItpatrutM.vue?vue&type=script&lang=js"

import "./ItpatrutM.vue?vue&type=style&index=0&id=4489ccd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4489ccd0"]])

export default __exports__